// eslint-disable-next-line @typescript-eslint/typedef
export const environment = {
	production: true,
};
